package dev.akshaychordiya.components.layouts

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.ColumnScope
import com.varabyte.kobweb.compose.foundation.layout.Spacer
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.core.PageContext
import com.varabyte.kobweb.core.data.getValue
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.toAttrs
import dev.akshaychordiya.components.sections.Footer
import dev.akshaychordiya.components.sections.NavHeader
import dev.akshaychordiya.content.Site
import kotlinx.browser.document
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.vh
import org.jetbrains.compose.web.dom.Div

/** The reading column. Capped so long prose never runs to an uncomfortable line length on a wide monitor. */
val PageContentStyle = CssStyle {
    base {
        Modifier
            .fillMaxWidth()
            .maxWidth(48.cssRem)
            .padding(leftRight = 1.5.cssRem, top = 1.cssRem)
    }
    Breakpoint.MD { Modifier.padding(leftRight = 2.cssRem, top = 2.cssRem) }
}

/** A wider column for pages whose content is visual rather than prose - the talks map, book covers. */
val WideContentStyle = CssStyle {
    base {
        Modifier
            .fillMaxWidth()
            .maxWidth(64.cssRem)
            .padding(leftRight = 1.5.cssRem, top = 1.cssRem)
    }
    Breakpoint.MD { Modifier.padding(leftRight = 2.cssRem, top = 2.cssRem) }
}

/**
 * @param title Shown in the browser tab, after the site name.
 * @param wide Opt into [WideContentStyle] for visual pages.
 */
class PageLayoutData(val title: String, val wide: Boolean = false)

@Composable
@Layout
fun PageLayout(ctx: PageContext, content: @Composable ColumnScope.() -> Unit) {
    val data = ctx.data.getValue<PageLayoutData>()
    LaunchedEffect(data.title) {
        document.title = if (data.title.isEmpty()) Site.NAME else "${data.title} · ${Site.NAME}"
    }

    Column(
        Modifier.fillMaxWidth().minHeight(100.vh),
        horizontalAlignment = Alignment.CenterHorizontally,
    ) {
        NavHeader()
        Div((if (data.wide) WideContentStyle else PageContentStyle).toAttrs()) {
            Column(Modifier.fillMaxWidth(), content = content)
        }
        // Absorbs leftover height so the footer sits at the bottom of the viewport on short pages,
        // rather than floating awkwardly under a half-empty screen.
        Spacer()
        Footer(Modifier.fillMaxWidth())
    }
}
